import React, { useState } from "react";
import "./upcomingevent.css";
import { FaCalendarAlt, FaUserTie, FaFemale, FaCamera, FaUserGraduate } from "react-icons/fa";

function UpcomingEvent() {
  const [awards] = useState([
    {
      id: 1,
      title: "Eye Care Hero Award",
      icon: <FaUserTie className="award-icon" />,
      description: "This platform helps optometry practitioners bring to light their own clinical practice.",
      eligibility: "Optometrists who have their own clinical practice",
      deadline: "30th October 2025, 5:30 pm  IST",
      format: "Video format (.mp4)",
      guidelines: [
        "You should be a registered delegate to submit your videos",
        "Duration: 2 minutes",
        "The video should portray your optometry practice, set up and expertise",
        "Speak about how it started, challenges faced, and current status",
        "Emphasize your area of speciality (if any)"
      ],
      evaluation: [],
      fileNameExample: "Name_Registration no (e.g., dharshika_deverndran_eyecare2026_002)"
    },
    {
      id: 2,
      title: "LeadHer Legacy Award",
      icon: <FaFemale className="award-icon" />,
      description: "This contest celebrates and empowers women in optometry who inspire, change, break barriers and lead the way.",
      eligibility: "Women optometrists, optometry faculties and researchers",
      deadline: "30th June 2025, 5:00 pm  IST",
      format: "PDF or Word document (.doc, .docx, .pdf)",
      guidelines: [
        "You should be a registered delegate to submit your documents",
        "Word limit: 500-1000 words",
        "Only individual submissions are permitted"
      ],
      evaluation: [
        "Leadership qualities and influence",
        "Inspiration and empowerment of other women",
        "Clarity and presentation of content"
      ],
      fileNameExample: "Name_Registration no (e.g., dharshika_deverndran_eyecare2026_002)"
    },


{
  id: 3,
  title: "NextGen Educator Excellence Award",
  icon: <FaUserGraduate className="award-icon" />,
  description: "Are you a student friendly teacher? Explore innovative teaching methods in your class? Then this contest is for you! This is for optometry faculties to present their groundbreaking and effective methods of teaching optometry and enhancing the way of learning optometry concepts.",
  eligibility: "Faculty members/HODs/Principal of optometry colleges who are willing to showcase their innovative ideas in teaching",
  deadline: "30th June 2025, before 5:00 pm  IST",
  format: "PDF or word document (.doc, .docx, .pdf)",
  guidelines: [
    "Faculties, HODs and Principal of optometry colleges can participate",
    "Minimum two years experience in teaching – Attach experience letter from college",
    "Individual or team submissions (max 3 members/team) are accepted",
    "Word limit – 500-1000 words",
    "Must include:",
    "Introduction: overview of the institution",
    "Innovative models: narrate about your novel and creative educational models",
    "Feedbacks: provide feedbacks from few of your students (max 5)",
    "Challenges and solutions: What were the challenges you faced",
    "Future roadmap: your plans for sustainability and scalability of these models"
  ],
  evaluation: [
    "Innovation and creativity",
    "Ideas for creating impact and maintaining sustainability",
    "The flow of ideas and the structural clarity of your content"
  ],
  fileNameExample: "Name_Registration no (e.g., john_doe_eyecare2026_003)"
},


{
  id: 4,
  title: "Selfie with Speakers",
  icon: <FaCamera className="award-icon" />,
  description: "Get ready to capture unforgettable moments with the esteemed speakers of Eye Care 2026. This contest is about capturing creative, fun and inspiring selfies with both national and international speakers of the day.",
  eligibility: "Optometry students who are attending the conference (Both UG and PG)",
  deadline: "17th August 2025, before 12:00 pm  IST",
  format: "Microsoft Word – .doc or .docx",
  guidelines: [
    "Must be a registered conference attendee",
    "Submit your best selfies with speakers",
    "Include a short caption about the experience",
    "Multiple entries allowed but must be with different speakers"
  ],
  evaluation: [
    "Creativity of the photo",
    "Engagement with the speaker",
    "Quality of the caption",
    "Overall fun factor"
  ],
  fileNameExample: "Name_pre-register number and instagram/facebook handle (e.g., john_doe_eyecare2026_004_@john_optom)"
}

  ]);

  const [activeAward, setActiveAward] = useState(awards[0]);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredAwards = awards.filter(award => 
    award && (
      (award.title && award.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (award.description && award.description.toLowerCase().includes(searchTerm.toLowerCase()))
    )
  );

  const renderGuidelines = (guidelines) => {
    if (!guidelines || !Array.isArray(guidelines)) return null;
    return guidelines.map((guideline, index) => <li key={index}>{guideline}</li>);
  };

  const renderEvaluation = (evaluation) => {
    if (!evaluation || !Array.isArray(evaluation)) return null;
    return evaluation.map((criteria, index) => <li key={index}>{criteria}</li>);
  };

  return (
    <div className="upcoming-container">
      {/* Award Details Section */}
      <div className="image-section">
        {activeAward && (
          <div className="award-details">
            <div className="award-details-header">
              {activeAward.icon}
              <h3>{activeAward.title}</h3>
            </div>
            
            <div className="detail-section">
              <h4>Description</h4>
              <p>{activeAward.description}</p>
            </div>
            
            <div className="detail-section">
              <h4>Who Can Apply</h4>
              <p>{activeAward.eligibility}</p>
            </div>
            
            <div className="detail-section">
              <h4>Deadline</h4>
              <p>{activeAward.deadline}</p>
            </div>
            
            <div className="detail-section">
              <h4>Submission Format</h4>
              <p>{activeAward.format}</p>
              {activeAward.fileNameExample && (
                <p className="file-example">{activeAward.fileNameExample}</p>
              )}
            </div>
            
            <div className="detail-section">
              <h4>Guidelines</h4>
              <ul>
                {renderGuidelines(activeAward.guidelines)}
              </ul>
            </div>
            
            {activeAward.evaluation && activeAward.evaluation.length > 0 && (
              <div className="detail-section">
                <h4>Evaluation Criteria</h4>
                <ul>
                  {renderEvaluation(activeAward.evaluation)}
                </ul>
              </div>
            )}
            
            <div className="contact-info">
              <p>For any queries, please contact: <a href="mailto:ecinstitute@gmail.com">ecinstitute@gmail.com</a></p>
            </div>
          </div>
        )}
      </div>



      {/* Awards Section */}
      <div className="events-section">
        <h1 className="title">Upcoming Events</h1>

        <input
          type="text"
          className="search-bar"
          placeholder="Search awards..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="event-list">
          {filteredAwards.length > 0 ? (
            filteredAwards.map((award) => (
              <div 
                key={award.id} 
                className={`event-card ${activeAward?.id === award.id ? 'active' : ''}`}
                onClick={() => setActiveAward(award)}
              >
                <div className="award-card-header">
                  {award.icon}
                  <h3 className="event-name">{award.title}</h3>
                </div>
                <p className="event-description">{award.description}</p>
                <div className="event-meta">
                  <span className="event-date"><FaCalendarAlt /> {award.deadline}</span>
                </div>
              </div>
            ))
          ) : (
            <p className="no-events">No upcoming event found</p>
          )}
        </div>
      </div>


    </div>
  );
}

export default UpcomingEvent;